module.exports = __webpack_public_path__ + "img/Sfondo_Nautico_MMIS.98d323e0.jpg";